import React, { useState } from 'react';
import RewardsLeaderBoard from './../../presentation/rewardsLeaderBoard/RewardsLeaderBoard.jsx';

const RewardsLeaderBoardContainer = ({ leaderboardData }) => {
	const [selectedFilter, setSelectedFilter] = useState('all');

	const getFilteredLeaderboardData = () => {
		if (!leaderboardData) return [];
		
		switch (selectedFilter) {
			case 'all':
				return leaderboardData.all || [];
			case 'department':
				return leaderboardData.department || [];
			case 'subcompany':
				return leaderboardData.subcompany || [];
			default:
				return leaderboardData.all || [];
		}
	};

	return (
		<div>
			<RewardsLeaderBoard
				leaderboardData={getFilteredLeaderboardData()}
				selectedFilter={selectedFilter}
				setSelectedFilter={setSelectedFilter}
			/>
		</div>
	);
};

export default RewardsLeaderBoardContainer;
